var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-tooltip", { attrs: { top: "" } }, [
    _c("span", { attrs: { slot: "activator" }, slot: "activator" }, [
      _vm.visualizedCodedEntry.imageBase64Value
        ? _c("img", {
            style: _vm.codeStyle,
            attrs: {
              draggable: false,
              src: "" + _vm.alertImageSourceType + _vm.alertImageSource
            }
          })
        : _vm._e(),
      !_vm.visualizedCodedEntry.imageBase64Value
        ? _c("span", { style: _vm.codeStyle }, [
            _vm._v(
              _vm._s(
                _vm._f("upperCaseFilter")(
                  _vm._f("firstCharacterFilter")(
                    _vm.visualizedCodedEntry.displayName
                  )
                )
              )
            )
          ])
        : _vm._e()
    ]),
    _c("span", [_vm._v(_vm._s(_vm.alertDisplayName))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }